module.exports = __webpack_public_path__ + "img/avatar0.ce98b607.png";